export const humanizeDate = (date) => {
  date = new Date(date)
  return date.toDateString()
}